import { t } from '../../i18n';

export const RECORDING_WAVE_BAR_COUNT = 33;

export function isSsoProvider(provider: string): boolean {
  return provider !== 'none' && provider !== 'otp';
}

export function getPlaceholder(authStatus: string): string {
  if (authStatus === 'unauthenticated') return t('inputPlaceholderEmail');
  if (authStatus === 'otp_pending') return t('inputPlaceholderOtp');
  return t('inputPlaceholder');
}

export function generateId(): string {
  return crypto.randomUUID();
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getFileIconPath(mimeType: string): string {
  if (mimeType === 'application/pdf') {
    return '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/><path d="M14 2v6h6"/><path d="M10 13h4"/><path d="M10 17h4"/><path d="M10 9h1"/>';
  }
  if (mimeType.startsWith('image/')) {
    return '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>';
  }
  return '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/><path d="M14 2v6h6"/>';
}

/** Truncate text for logging - keeps first 200 chars */
export function truncateLog(text: string, max = 200): string {
  if (text.length <= max) return text;
  return text.slice(0, max) + `… [${text.length} chars]`;
}

export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
